import {
//    getOriginRoot,
    getURLParams,
} from '../../../../commons/utils/constants';


/*

    PAGES URLS
    /schedules
    /calendars
    /subscriber
    /success

    /loading
    /inappredirect
    /inAppGuide
    /oauthlauncher
    /oauthTalking
    
    /oauthloading
    /oauthfail

    /icslink
    /almostdone
    /outlook-new
    /outlook-new-guide
    /havingtrouble
    /errors
    /               
*/

export function indexHistory (query) {
    console.log('indexHistory()');
    window.history.replaceState({url: '/'}, '', `/${query}`);
} 

export function defaultHistory (query) {
    console.log('defaultHistory()');
    window.history.pushState({url: '/schedules'}, '', `/schedules${query}`);
    window.history.replaceState({url: '/calendars'}, '', `/calendars${query}`);
}

export function withSchedules (query) {
    console.log(`withSchedules() pushing /schedules${query}` , );
    window.history.pushState({url: '/schedules'}, '', `/schedules${query}`);
}

export function withCalendars (query) {
    console.log('withCalendars()');
    window.history.pushState({url: '/schedules'}, '', `/schedules${query}`);
    window.history.pushState({url: '/calendars'}, '', `/calendars${query}`);
}

export function withSubscriber (query) {
    console.log('withSubscriber()');
    window.history.pushState({url: '/schedules'}, '', `/schedules${query}`);
    window.history.pushState({url: '/calendars'}, '', `/calendars${query}`);
    window.history.pushState({url: '/subscriber'}, '', `/subscriber${query}`);
}

export function withAlmostDone (query) {
    window.history.pushState({url: '/schedules'}, '', `/schedules${query}`);
    window.history.pushState({url: '/calendars'}, '', `/calendars${query}`);
    window.history.pushState({url: '/subscriber'}, '', `/subscriber${query}`);
    window.history.pushState({url: '/almostdone'}, '', `/almostdone${query}`);
}

export function withOutlookNew (query) {
    window.history.pushState({}, '', `/schedules${query}`);
    window.history.pushState({}, '', `/calendars${query}`);
    window.history.pushState({}, '', `/outlook-new${query}`);
}

const navStates = {
    '/schedules': withSchedules,
    '/calendars': withCalendars,
    '/subscriber': withSubscriber,
    '/almostdone': withAlmostDone,

    '/icslink': withSubscriber,
    '/outlook-new-guide': withOutlookNew,

    '/oauthlauncher': withCalendars,
    '/success': defaultHistory, // ensure that on success, users cannot navigate to others
    '/errors': defaultHistory,
    '/oauthfail': defaultHistory,
    '/oauthTalking': defaultHistory,
    '/': indexHistory,
    '/loading':  indexHistory,
};
 

export function fixURLHistory (page, query) {
    const hfunc = navStates[page];
    console.log(`fixURLHistory() ${page}${query}`);
    console.log('fixURLHistory()', hfunc);
    if (page.indexOf('inAppGuide') === 1) {
        withCalendars(query);
        return; 
    }
    
    if (typeof hfunc === 'function') {
        hfunc(query);
    } else {
        defaultHistory(query);
    }
}

/* 
 * goto is used by both front end back.
 */

function goto (page) {
    this.page = page;
    const query = getURLParams();
    // console.log(`goto() ${page}${query}`);
    // this.fixURLHistory(page, query);
    const state = { url: page };
    // console.log('goto()  page state: ', state);

    this.navigate(`${page}${query}`, { state, replace: true });   
}

export default goto;
